import React from "react";

const Location = () => {
  return (
    <div className="flex flex-col justify-start dark:bg-[#1A1A1A]">
      <section className="py-8 sm:py-16 px-4 lg:px-6 mx-auto max-w-screen-xl">
        {/* Use a responsive grid on medium+ screens; stack on small screens */}
        <div className="grid gap-8 items-start md:grid-cols-2 xl:gap-16">
          {/* LEFT COLUMN */}
          <div>
            <h2 className="mb-4 text-2xl sm:text-3xl md:text-4xl font-extrabold text-white">
              Мы находимся
            </h2>
            <p className="mb-6 font-light text-gray-400 md:text-lg">
              По улице 1-проезд улицы Шота Руставели, 6 дом. Ориентир: Гостиница “Lumiere Mercure”
            </p>
            <p className="mb-6 font-light text-gray-400 md:text-lg">
              Режим работы: 7:00 - 23:00
            </p>
            <div>
              <a
                href="https://yandex.uz/maps/org/lumiere/212483938535/?ll=69.241990%2C41.272268&z=16.85"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-white border-2 border-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5"
              >
                В путь
                <svg
                  className="ml-2 -mr-1 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 
                    6a1 1 0 010 1.414l-6 
                    6a1 1 0 01-1.414-1.414L14.586 
                    11H3a1 1 0 110-2h11.586l-4.293-4.293a1 
                    1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </a>
            </div>
          </div>

          {/* RIGHT COLUMN: RESPONSIVE MAP */}
          <div className="flex justify-center md:justify-end">
            {/* Make the iframe fill the container and scale by height for smaller screens */}
            <iframe
              src="https://yandex.com/map-widget/v1/?um=constructor%3Ae86f0647ee5d79a4c281ac51f63c0b09bbdf564bc17b671b8460cf782bc3676f&amp;source=constructor"
              className="w-full h-[300px] sm:h-[400px] border-none rounded-lg"
              frameBorder="0"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Location;
